import * as z from "zod";

export const getDemoConciergeKnowledge = {
  name: "getDemoConciergeKnowledge" as const,
  input: z.null(),
  output: z
    .object({ _id: z.string(), title: z.string(), content: z.string() })
    .nullable(),
};
